import styled from "styled-components";
import Container from "../../Components/Container";
import Row from "../../Components/Row";
// import AlfredImg from "../../assets/images/alfred.png";
import AlfredGif from "../../assets/images/alfred-2.gif";

const Title = styled.h1`
  font-weight: 700;
  font-size: 40px;
  color: #000000;
`;

const TitleInfo = styled.span`
  font-weight: 700;
  font-size: 20px;
  color: #000000;
  margin-bottom: 15px;
  line-height: 30px;
`;
const SubTitleInfo = styled.h1`
  font-weight: 200;
  font-size: 16px;
  color: #000000;
  line-height: 30px;
  margin-bottom: 40px;
`;

const About = () => {
  return (
    <Container
      style={{
        textAlign: "center",
        backgroundColor: "#E4DA1B",
        paddingTop: "80px",
        paddingBottom: "80px",
      }}
      id="section-2"
    >
      <Title>Rápido e Fácil</Title>
      <Row lg="1fr 1fr" sm="1fr" style={{ alignItems: "center", width: '100%' }}>
        <img src={AlfredGif} alt="alfred" style={{margin: 'auto', maxWidth: '80%'}} />
        <div style={{ textAlign: "left" }}>
          <TitleInfo>Configure o agente</TitleInfo>
          <SubTitleInfo>
            Insira instruções, fluxos de atendimeto e regras de comportamento.
          </SubTitleInfo>
          <TitleInfo>Alimente a Base de Conhecimento</TitleInfo>
          <SubTitleInfo>
            Insira qualquer tipo de informação sobre o seu negócio: textos, imagens, catálogos, etc..
          </SubTitleInfo>
          <TitleInfo>Conecte ao Whatsapp</TitleInfo>
          <SubTitleInfo>
            Em minutos, o Alfred estará no seu número de atendimento.
          </SubTitleInfo>
        </div>
      </Row>
    </Container>
  );
};

export default About;
